export const cmvReportV2 = {
	label: "CMV",
	description:
		"O CMV (Custo de Mercadorias Vendidas) é um indicador financeiro que representa os custos diretos.",
	states: {
		empty: {
			title: "Nenhum dado de CMV encontrado",
			description: "Não há informações de CMV para o período selecionado.",
		},
		error: {
			title: "Não foi possível carregar o CMV",
			description:
				"Ocorreu um erro ao carregar o relatório de CMV. Tente novamente em instantes.",
		},
	},
	kpis: {
		itemsSold: "Itens vendidos",
		grossRevenue: "Faturamento bruto",
		totalCost: "Custo total",
		marginCmv: "Margem CMV",
		cmvPercent: "CMV em porcentagem",
	},
	header: {
		periodPlaceholder: "Selecione o período",
		export: "Exportar Excel",
		type: {
			all: "Todos os produtos",
			fromPlace: "Produtos do place",
			fromVendor: "Produtos do fornecedor",
		},
	},
	filters: {
		searchPlaceholder: "Buscar por produto ou SKU",
		categoriesPlaceholder: "Todas as categorias",
		viewBy: {
			byCategory: "Visualizar por categorias",
			byProduct: "Visualizar por produtos",
		},
	},
	chart: {
		title: "Faturamento vs CMV por categorias",
		legend: {
			revenue: "Faturamento",
			cmv: "CMV",
		},
		tooltip: {
			revenue: "Faturamento",
			cmv: "CMV",
		},
		empty: {
			title: "Sem dados para o gráfico",
			description: "Nenhuma categoria com vendas no período e filtros selecionados.",
		},
	},
	table: {
		columns: {
			category: "CATEGORIA",
			soldQty: "QTD VENDIDA",
			grossRevenue: "FATURAMENTO BRUTO",
			totalCost: "CUSTO TOTAL",
			costPercent: "CUSTO PERCENTUAL",
			cmv: "CMV",
			margin: "MARGEM",
			product: "Produto",
			sku: "SKU",
			productSoldQty: "QTD vendida",
			losses: "Perdas",
			unitValue: "Valor unit.",
			unitCost: "Custo Unit.",
			productTotalValue: "Valor total",
			productTotalCost: "Custo total",
			productMargin: "Margem",
			productCmv: "CMV",
		},
		empty: {
			title: "Nenhum produto encontrado",
			description: "Não há produtos para os filtros selecionados.",
		},
	},
};
